import { routes } from '@/fsd/shared/config/routes/routesConfig';
import { Button, Input } from '@/fsd/shared/ui';
import { CodeInput } from '@/fsd/shared/ui/code-input/CodeInput';
import FormField from '@/fsd/shared/ui/form-field/FormField';
import BackArrow from '@/fsd/shared/ui/icons/back-arrow';
import React from 'react';
import { usePasswordReset } from '../hooks/usePasswordReset';
import style from './PasswordReset.module.scss';

const PasswordReset = () => {
  const {
    email,
    formErrors,
    handleEmailChange,
    handleSubmit,
    codeStatus,
    isThrottled,
    remainingTime,
    authPasswordResetConfirmStatus,
    handleCodeComplete,
    newPassword,
    confirmPassword,
    handleNewPasswordChange,
    handleConfirmPasswordChange,
  } = usePasswordReset();

  return (
    <main className={style.main}>
      <form className={style.mainForm}>
        <div className={style.header}>
          <div className={style.backButton}>
            <Button
              variant="link"
              type="button"
              onClick={() => window.history.back()}
            >
              <BackArrow />
            </Button>
          </div>
          <div className={style.mainFormTitle}>Восстановление пароля</div>
          <div className={style.loginLinks}></div>{' '}
        </div>

        <div className={style.inputContainer}>
          <FormField
            label="Введите почту для восстановления пароля"
            error={formErrors.email}
          >
            <Input
              type="email"
              name="email"
              onChange={handleEmailChange}
              className={style.input}
              value={email}
            />
          </FormField>
        </div>

        <div className={style.inputContainer}>
          <FormField label="Новый пароль" error={formErrors.newPassword}>
            <Input
              type="password"
              name="newPassword"
              onChange={handleNewPasswordChange}
              className={style.input}
              value={newPassword}
            />
          </FormField>
        </div>

        <div className={style.inputContainer}>
          <FormField
            label="Подтвердить новый пароль"
            error={formErrors.confirmPassword}
          >
            <Input
              type="password"
              name="confirmPassword"
              onChange={handleConfirmPasswordChange}
              className={style.input}
              value={confirmPassword}
            />
          </FormField>
        </div>

        {formErrors.general && (
          <div className={style.generalError}>{formErrors.general}</div>
        )}

        {!codeStatus ? (
          <Button
            className={style.AccountBtn}
            type="button"
            disabled={isThrottled}
            variant={'auth-button'}
            onClick={handleSubmit}
          >
            {isThrottled
              ? `Получить код повторно через ${remainingTime} с`
              : 'Запросить проверочный код'}
          </Button>
        ) : (
          <div className={style.accountBtnWrapper}>
            <CodeInput
              length={6}
              onComplete={handleCodeComplete}
              className={style.codeInput}
              status={authPasswordResetConfirmStatus}
            />
            <Button
              className={style.AccountBtn}
              type="button"
              onClick={handleSubmit}
              disabled={isThrottled}
              variant={'auth-button'}
            >
              {isThrottled
                ? `Получить код повторно через ${remainingTime} с`
                : 'Отправить проверочный код'}
            </Button>
          </div>
        )}
      </form>

      <a href={routes.home.path} className={style.homeBackLink}>
        Вернуться на главную
      </a>
    </main>
  );
};

export default PasswordReset;
